<template>
	<div>
		<hr>
		<div class="m-header-wrapper">
			<table class="m-header">
				<thead class='bold'>
					<tr>
                        <th>Федеральные округа, Субъекты Российской Федерации</th>
                        <th>Плановые годовые объёмы лесопатологических обследований(в соответствии с бюджетными проектировками), га</th>
                        <th>Объёмы выполненных лесопатологических обследований (в соответствии с опубликованными на сайтах актами ЛПО), га</th>
                        <th>% выполнения</th>
                        <td class='m-scroll'></td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>2</td>
                        <td>3</td>
                        <td>4</td>
                    </tr>
				</thead>
			</table>
		</div>
		<div class="m-body-wrapper">
			<table class='m-body'>			
				<tbody>
					<tr v-for='(row, i) in rows' :class='(row.bold ? "bold" :"")' :key='row.region + i'>
						<td v-if='row.new_fo' colspan="4" style="padding-top: 7px; padding-bottom: 7px;"><span class="bold">{{row.fo}}</span></td>
						<td v-if='!row.new_fo' class='left m-td'>{{row.region}}</td>
						<td v-if='!row.new_fo' class='right m-td'>{{row.lpo_volume_plan}}</td>
						<td v-if='!row.new_fo' class='right m-td'>{{row.lpo_volume}}</td>
						<td v-if='!row.new_fo' class='right m-td'>{{row.proc}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_STAT_LPO_REPORT = 'get_stat_lpo_report.php'
	const REPORT_ID = 12

	export default {
		name: 'StatLpo',
		data: function () {
			return {
				rows: [],
				total_row: {}
			}
		},
		props: [
			'year'
		],
		computed: {
			endYear () {
				return this.$props.end.split('.')[2]
			}
		},
		methods: {
			fillTable (year) {
				fetch(DB + GET_STAT_LPO_REPORT + '?year=' + year)
				.then(res => res.json())
				.then(res => {
					//let temp_rows = [{}]
					//let flag = true
					//let total_summ = {}
                    /*
                        total_summ.region = 'Итого по РФ'
                        total_summ.placement_all = 0
                        total_summ.placement_week = 0
                        total_summ.entrance_all = 0
                        total_summ.entrance_week = 0
                        total_summ.sending_conclusion_all = 0
                        total_summ.sending_conclusion_week = 0
                        total_summ.decision_false_all = 0
                        total_summ.decision_false_week = 0
                        total_summ.deletion_all = 0
                        total_summ.deletion_week = 0
                        total_summ.online_acts_all = 0
                        total_summ.online_acts_week = 0

                        let fo_summ = {}
                        fo_summ.region = 'Итого по округу'
                        fo_summ.placement_all = 0
                        fo_summ.placement_week = 0
                        fo_summ.entrance_all = 0
                        fo_summ.entrance_week = 0
                        fo_summ.sending_conclusion_all = 0
                        fo_summ.sending_conclusion_week = 0
                        fo_summ.decision_false_all = 0
                        fo_summ.decision_false_week = 0
                        fo_summ.deletion_all = 0
                        fo_summ.deletion_week = 0
                        fo_summ.online_acts_all = 0
                        fo_summ.online_acts_week = 0
                    */
					   
					this.total_row = {}
					this.rows = []
					let i = 0
                    let last_fo = null
                    
                    let current_lpo_volume_plan = 0
                    let current_lpo_volume = 0
                    let russia_lpo_volume_plan = 0
                    let russia_lpo_volume = 0

                    for(let row_index in res) {
						if(res[row_index].fo_id == null) {
							this.total_row = JSON.parse(JSON.stringify(res[row_index]))
							continue
                        }
                        

                        if(row_index == 0 )
                            this.rows.push({
                                new_fo: true,
                                region: res[row_index].fo,
                                fo: res[row_index].fo
                            })

                        if(res[row_index].fo != last_fo && row_index > 0) {
                            this.rows.push({
                                bold: true,
                                region: 'Итого по округу',
                                lpo_volume_plan: +current_lpo_volume_plan.toFixed(2),
                                lpo_volume: +current_lpo_volume.toFixed(2),
                                proc: +Number(100 * current_lpo_volume / current_lpo_volume_plan).toFixed(2)
                            })
                            this.rows.push({
                                new_fo: true,
                                region: res[row_index].fo,
                                fo: res[row_index].fo
                            })
                            current_lpo_volume_plan = 0
                            current_lpo_volume = 0
                        }
                        current_lpo_volume_plan += +res[row_index].lpo_volume_plan
                        current_lpo_volume += +res[row_index].lpo_volume
                        russia_lpo_volume_plan += +res[row_index].lpo_volume_plan
                        russia_lpo_volume += +res[row_index].lpo_volume
                        
                        this.rows.push(res[row_index])
                        last_fo = res[row_index].fo
                    }
                    this.rows.push({
                        bold: true,
                        region: 'Итого по округу',
                        lpo_volume_plan: +current_lpo_volume_plan.toFixed(2),
                        lpo_volume: +current_lpo_volume.toFixed(2),
                        proc: +Number(100 * current_lpo_volume / current_lpo_volume_plan).toFixed(2)
                    })

					this.total_row = {
                        lpo_volume_plan: +russia_lpo_volume_plan.toFixed(2),
                        lpo_volume: +russia_lpo_volume.toFixed(2),
                        proc: +Number(100 * russia_lpo_volume / russia_lpo_volume_plan).toFixed(2)
                    }
					if(this.total_row) {
						this.total_row.bold = true
						this.rows.unshift(this.total_row)

						this.rows.unshift({
								new_fo: true,
								bold: true,
								region: 'Итого по РФ',
								fo: 'Итого по РФ'
							})
					}						

					/*while (i < res.length - 1) {

						if ((res[i].fo === res[i+1].fo) && flag) {
							let obj = {}
							obj.fo = res[i].fo
							obj.flag = true
							flag = false

							if (i !== 0) {
								let clone_fo = {} //клонируем объект для передачи по значению
								for (let key in fo_summ) {
									clone_fo[key] = fo_summ[key]
								}

								temp_rows.push(clone_fo)

								/*fo_summ.placement_all = 0
								fo_summ.placement_week = 0
								fo_summ.entrance_all = 0
								fo_summ.entrance_week = 0
								fo_summ.sending_conclusion_all = 0
								fo_summ.sending_conclusion_week = 0
								fo_summ.decision_false_all = 0
								fo_summ.decision_false_week = 0
								fo_summ.deletion_all = 0
								fo_summ.deletion_week = 0
								fo_summ.online_acts_all = 0
								fo_summ.online_acts_week = 0
						}

						temp_rows.push(obj)						
					}
					else {
						/*total_summ.placement_all += +res[i].placement_all
						total_summ.placement_week += +res[i].placement_week
						total_summ.entrance_all += +res[i].entrance_all
						total_summ.entrance_week += +res[i].entrance_week
						total_summ.sending_conclusion_all += +res[i].sending_conclusion_all
						total_summ.sending_conclusion_week += +res[i].sending_conclusion_week
						total_summ.decision_false_all += +res[i].decision_false_all
						total_summ.decision_false_week += +res[i].decision_false_week
						total_summ.deletion_all += +res[i].deletion_all
						total_summ.deletion_week += +res[i].deletion_week
						total_summ.online_acts_all += +res[i].online_acts_all
						total_summ.online_acts_week += +res[i].online_acts_week

						fo_summ.placement_all += +res[i].placement_all
						fo_summ.placement_week += +res[i].placement_week
						fo_summ.entrance_all += +res[i].entrance_all
						fo_summ.entrance_week += +res[i].entrance_week
						fo_summ.sending_conclusion_all += +res[i].sending_conclusion_all
						fo_summ.sending_conclusion_week += +res[i].sending_conclusion_week
						fo_summ.decision_false_all += +res[i].decision_false_all
						fo_summ.decision_false_week += +res[i].decision_false_week
						fo_summ.deletion_all += +res[i].deletion_all
						fo_summ.deletion_week += +res[i].deletion_week
						fo_summ.online_acts_all += +res[i].online_acts_all
						fo_summ.online_acts_week += +res[i].online_acts_week

						temp_rows.push(res[i])
						if (res[i].fo !== res[i+1].fo) {
							flag = true
						}
						i++
					}*/

                /*
                    let last = res.length - 1

                    temp_rows.push(res[last])

                    fo_summ.placement_all += +res[last].placement_all
                    fo_summ.placement_week += +res[last].placement_week
                    fo_summ.entrance_all += +res[last].entrance_all
                    fo_summ.entrance_week += +res[last].entrance_week
                    fo_summ.sending_conclusion_all += +res[last].sending_conclusion_all
                    fo_summ.sending_conclusion_week += +res[last].sending_conclusion_week
                    fo_summ.decision_false_all += +res[last].decision_false_all
                    fo_summ.decision_false_week += +res[last].decision_false_week
                    fo_summ.deletion_all += +res[last].deletion_all
                    fo_summ.deletion_week += +res[last].deletion_week
                    fo_summ.online_acts_all += +res[last].online_acts_all
                    fo_summ.online_acts_week += +res[last].online_acts_week

                    total_summ.placement_all += +res[last].placement_all
                    total_summ.placement_week += +res[last].placement_week
                    total_summ.entrance_all += +res[last].entrance_all
                    total_summ.entrance_week += +res[last].entrance_week
                    total_summ.sending_conclusion_all += +res[last].sending_conclusion_all
                    total_summ.sending_conclusion_week += +res[last].sending_conclusion_week
                    total_summ.decision_false_all += +res[last].decision_false_all
                    total_summ.decision_false_week += +res[last].decision_false_week
                    total_summ.deletion_all += +res[last].deletion_all
                    total_summ.deletion_week += +res[last].deletion_week
                    total_summ.online_acts_all += +res[last].online_acts_all
                    total_summ.online_acts_week += +res[last].online_acts_week

                    let clone_fo = {} //клонируем объект для передачи по значению
                    for (let key in fo_summ) {
                        clone_fo[key] = fo_summ[key]
                    }

                    temp_rows.push(clone_fo)

                    temp_rows[0] = total_summ

                    this.rows = temp_rows
                */
			})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			this.rows = []
			this.fillTable(this.year)

			EventBus.$on('stat-lpo-date', date => {
				// console.log('mon',date)
				this.fillTable(date.year)
			})

			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent

			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - 30 - scroll_width
			const col_width = Math.ceil(table_width / 13)
			

			document.querySelectorAll('.m-td').forEach(td => {
				td.width = col_width
			})
			document.querySelector('.m-header-wrapper').width = table_width
			document.querySelector('.m-body-wrapper').width = table_width
			document.querySelector('.m-body-wrapper').style.maxHeight = `${dispay_height - 280}px`

			// console.log(dispay_width, col_width, table_width)

			document.querySelector('.m-scroll').width = scroll_width

		},
		created() {
			if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')
		},
		beforeDestroy() {
			EventBus.$off('stat-lpo-date')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
		padding-left: 2px;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.m-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		/*width: 1574px;*/
		/*width: 1634px;*/
	}

	div.m-body-wrapper {
		overflow-x: hidden;
		overflow-y: auto;
		/*width: 1574px;*/
		/*width: 1634px;*/
		border: 1px solid black;
		border-top: none;
	}

	table.m-header {
		border-bottom: 1px solid black;
		table-layout: fixed;
		width: 100%;
	}

	table.m-body {
		table-layout: fixed;
		width: 100%;
	}
	
 	td.m-td,  th.m-td {
	vertical-align: middle;  
	/*width: 120px;*/
	/*width: 124px;*/
	word-wrap: break-word;
} 

	/* td.m-scroll {
		width: 14px;
		width: 17px;
	} */
</style>



// WEBPACK FOOTER //
// StatLpo.vue?952b3642